// extracted by mini-css-extract-plugin
module.exports = {"big-logo-wrap":"_34kau","nav-section":"_1y-JX","trademark":"_3-Tad"};